import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { AxiosInstance, END_POINTS } from '../../integrations'

export const changeMyProfileName = createAsyncThunk(
    'post/profileName',
    async ({ displayName, appUserId }: any) => {
        try {
            const seasonKeyword =
                window.localStorage.getItem('SEASON_KEYWORD_CONFIG') || 'free'
            const response: usersRequest = await AxiosInstance.put(
                END_POINTS.registrationsApi,
                {
                    accountId: +appUserId,
                    displayName: displayName,
                    version: 'mock',
                    seasonKey: seasonKeyword,
                }
            )
            return response
        } catch (error: any) {
            return error
        }
    }
)

export const fetchMyProfile = createAsyncThunk(
    'get/getUser',
    async (MockAccId?: string | undefined | null) => {
        let userKey = window.localStorage.getItem('MOCK_ACC_ID')
        if (MockAccId) {
            userKey = MockAccId
        }
        const boardName = 'mock'
        try {
            const response: usersRequest = await AxiosInstance.get(
                `${END_POINTS.userAPIS}${userKey}/rank/${boardName}`
            )
            return response
        } catch (error: any) {
            return error.message
        }
    }
)

export const fetchPerformance = createAsyncThunk(
    'get/getPerformance',
    async ({ date, mockAccId }: any) => {
        let userKey = mockAccId
        if (!mockAccId) {
            userKey = window.localStorage.getItem('MOCK_ACC_ID')
        }
        try {
            const response: performanceRequest = await AxiosInstance.get(
                `${END_POINTS.reporting}${userKey}/profile-statistics/${date}`
            )
            return response
        } catch (error: any) {
            return error.message
        }
    }
)

export const fetchChartPerformance = createAsyncThunk(
    'get/getChartData',
    async ({ mockAccId, startDate, timeFormat }: any) => {
        let userKey = window.localStorage.getItem('MOCK_ACC_ID')
        if (mockAccId) {
            userKey = mockAccId
        }
        try {
            const response: performanceAllRequest[] = await AxiosInstance.get(
                `${END_POINTS.reporting}${userKey}/profile-timeseries?start=${startDate}&tf=${timeFormat}`
            )
            return response
        } catch (error: any) {
            return error.message
        }
    }
)

const initialState: myProfileState = {
    status: 'idle',
    error: '',
}

export const myProfileSlice = createSlice({
    name: 'myProfile',
    initialState,
    reducers: {},
    extraReducers(buidler) {
        buidler
            .addCase(fetchMyProfile.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(fetchMyProfile.fulfilled, (state, action) => {
                state.status = 'success'
                state.user = action.payload
                state.error = undefined
            })
            .addCase(fetchMyProfile.rejected, (state, action) => {
                state.status = 'rejected'
                state.error = action.error.message
            })
            .addCase(fetchPerformance.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(fetchPerformance.fulfilled, (state, action) => {
                state.status = 'success'
                state.performance = action.payload
            })
            .addCase(fetchPerformance.rejected, (state, action) => {
                state.status = 'rejected'
                state.error = action.error.message
            })
            .addCase(fetchChartPerformance.pending, (state, action) => {
                state.status = 'pending'
                state.performanceAll = []
            })
            .addCase(fetchChartPerformance.fulfilled, (state, action) => {
                state.status = 'success'
                state.performanceAll = action.payload
            })
            .addCase(fetchChartPerformance.rejected, (state, action) => {
                state.status = 'rejected'
                state.error = action.error.message
            })
            .addCase(changeMyProfileName.rejected, (state, action) => {
                state.status = 'rejected'
                state.error = action.error.message
            })
            .addCase(changeMyProfileName.pending, (state, action) => {
                state.status = 'pending'
                state.error = ''
            })
            .addCase(changeMyProfileName.fulfilled, (state, action) => {
                state.status = 'success'
            })
    },
})

export default myProfileSlice.reducer
